module.exports = __webpack_public_path__ + "static/img/zhongjin@2x.8450a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/zhongjin@2x.png
// module id = QqS3
// module chunks = 1